import React from "react";
import { PieChart, Pie, Tooltip, Cell } from "recharts";

const data = [
  { name: "Monday", value: 8 },
  { name: "Tuesday", value: 6.5 },
  { name: "Wednesday", value: 7.1 },
  { name: "Thursday", value: 5.3 },
  { name: "Friday", value: 6 },
  { name: "Saturday", value: 7 },
  { name: "Sunday", value: 6.3 }
];

const SimplePieChart = () => {
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#85B09F",
    "#C0532F",
    "#073F4D"
  ];
  return (
    <PieChart width={500} height={400}>
      <Pie
        dataKey="value"
        data={data}
        cx={250}
        cy={200}
        innerRadius={40}
        outerRadius={80}
        fill="#82ca9d"
        label
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip />
    </PieChart>
  );
};

export default SimplePieChart;
